
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "title": "whenisgoldenhour.com",
  "created": "2017-08-06",
  "categories": "[\"dev\", \"golden hour\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "tags": [
    "dev",
    "golden hour"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["There are a ton of tools out there for finding sunrise, sunset, golden hour, etc. for a particular day in a particular spot on earth. ",{"type":"a","props":{"href":"http://golden-hour.com/"},"children":["The Golden Hour Calculator"]}," being the one I frequented."]},"\n",{"type":"p","props":{},"children":["None of these tools are great at quickly exposing the one time range for so many photographers love most -- golden hour. So was born ",{"type":"a","props":{"href":"http://whenisgoldenhour.com"},"children":["whenisgoldenhour.com"]},". The site will do its best to grab the city you're standing in, and display the start and end time of golden hour for the current day. That's it."]},"\n",{"type":"p","props":{},"children":[{"type":"img","props":{"src":"/static/images/posts/2017-08-06-whenisgoldenhour/screenshot1.png","alt":"screen"}}]},"\n",{"type":"p","props":{},"children":["Enjoy!"]},"\n",{"type":"p","props":{},"children":["Update:\nAfter posting the ",{"type":"a","props":{"href":"https://www.reddit.com/r/photography/comments/6q4xri/built_a_site_to_quickly_find_out_when_golden_hour/"},"children":["link to reddit"]},", some useful improvements I might include:  "]},"\n",{"type":"ul","props":{},"children":["\n",{"type":"li","props":{},"children":["Use 24hr time for users outside US  "]},"\n",{"type":"li","props":{},"children":["Toggle for morning golden hour  "]},"\n"]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
